import {
  FETCH_CLIENT_LANGUAGES_BEGIN,
  FETCH_CLIENT_LANGUAGES_DONE,
  FETCH_CLIENT_LANGUAGES_FAILED,
  FETCH_LOCALE_DATA,
  SET_CLIENT_LANGUAGE_BEGIN,
  SET_CLIENT_LANGUAGE_DONE,
} from "../actions/localizationActions";
import lodash from "lodash";

const initialState = {
  languages: {
    all: [],
    byId: {},
  },
  i18nResources: {},
  selectedLanguage: {},
  lfetching: false,
  lfetched: false,
  lerror: null,
  rfetchingId: null,
  rerror: null,
  updatingLocale: false,
  localeResourcesFetched: false,
  changingLanguage: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    /* Client languages is interesting for the language selector dropdown */
    case FETCH_CLIENT_LANGUAGES_BEGIN:
      return { ...state, lfetching: true };
    case FETCH_CLIENT_LANGUAGES_DONE: {
      return {
        ...state,
        languages: {
          all: action.payload,
          byId: action.payload.reduce(
            (prev, cur) => ({
              ...prev,
              [cur.id]: { ...cur },
            }),
            {}
          ),
        },
      };
    }
    case FETCH_CLIENT_LANGUAGES_FAILED:
      return { ...state, fetching: false, lerror: action.payload };

    case FETCH_LOCALE_DATA: {
      const resource = {};
      resource[action.payload.id] = action.payload.resource;
      // TODO: No checking if a state change is really necessary,
      //   that is, if the locale resource is already in the store.
      return {
        ...state,
        rfetchingId: null,
        i18nResources: Object.assign({}, state.i18nResources, resource),
        localeResourcesFetched: true,
      };
    }
    /* BEGIN: Refactored language selection API */
    case SET_CLIENT_LANGUAGE_BEGIN:
      return {
        ...state,
        changingLanguage: true,
      };
    case SET_CLIENT_LANGUAGE_DONE:
      return {
        ...state,
        changingLanguage: false,
        selectedLanguage: action.currentLang,
      };
    /* END: Refactored language selection API */

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/localizationReducer.jsx